// src/components/StationBlockItem.jsx
import React from 'react';
import { trainKindClass } from '../../data/trainKinds';
import { trainHtmlClass, displayDelay } from '../../services/trainsService';

const StationBlockItem = ({ trains, keyPrefix, trainBodyClass, eventsEmit }) => (
  <div key={keyPrefix} className="station-block-item">
    {trains.map((train, idx) => (
      <a
        href={`/lines/mainline/trains/${train.train_number}`}
        key={`${keyPrefix}_${idx}`}
        className={`train-icon train${train.train_number}`}
        onClick={
          (event) => {
            event.preventDefault();
            eventsEmit('train_position.train', { train_number: train.train_number });
            window.location.href = event.currentTarget.href;
          }
        }
      >
        <div
          className={`train-body ${trainHtmlClass(train)} ${trainKindClass(train.train_kind_id)} ${trainBodyClass}`}
        />
        {train.delay && train.delay > 59 ? (
          <p className={`train-delay ${train.direction}`}>
            {displayDelay(train.delay)}
          </p>
        ) : null}
      </a>
    ))}
  </div>
);

export default StationBlockItem;
